export default {
  getBroadcasts: (state) => state.broadcasts,
  getBroadcastsCount: (state) => state.broadcastsCount
}
